/**
 * The Accounts status the API sends on assignees (UserCache.accountStatus).
 * Suspended/deleted/missing people are hidden from every list and picker;
 * where they are still attached to live work — an open task — they render
 * with a badge so someone reassigns it. See docs/user-status.md.
 */
export function isInactiveAccount(status?: string | null): boolean {
  return status === 'suspended' || status === 'deleted' || status === 'missing';
}

/** The badge text: "Suspended" for a suspension, "Removed" otherwise. */
export function inactiveAccountLabel(status?: string | null): string {
  return status === 'suspended' ? 'Suspended' : 'Removed';
}
